export const environment = {
    BUILD_PRODUCT: "landing-page",
    API_URL_BASE: "https://api.12082026.xyz/",
    API_USER_SELF: "v1/users/self",
    PRODUCT_URLS: {
        LANDING_PAGE: "https://12082026.xyz",
        ACCOUNT: "https://account.12082026.xyz",
        ACCOUNT_USER_REGISTRATION: "https://account.12082026.xyz/register",
        ACCOUNT_BUSINESS_REGISTRATION: "https://account.12082026.xyz/register-business",
        RESTAURANT: "https://restaurant.12082026.xyz",
        USER_APP: "https://app.12082026.xyz",
    },
    MOBILE_GOOGLE_PLAY_URL: "https://play.google.com/",
    MOBILE_APP_STORE_URL: "https://www.apple.com/app-store/",
    DEBUG_STAGING_BADGE: true
};
